import styled from 'styled-components'

export const Container = styled.div``

export const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  border: 1px solid #49494970;
  border-radius: 6px;
  overflow-x: auto;
  max-height: 70vh;

  > div {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
  }
  /* border: ; */
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 30px;

  th {
    text-wrap: nowrap;
  }
  > thead {
    position: sticky;
    top: 0;
    background: #fff;
    > hr {
      width: 100%;
      margin: 0;
    }
  }
  > tbody {
    tr {
      background: #fff;
      border-spacing: 1em 0.5em;
      padding: 0 2em 1em 0;
      border: 3px solid #ffffff;
    }
    th {
      background-color: #49494970;
    }
  }
`

export const TableHeader = styled.th`
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #00000020;
  font-size: ${(props) => props.theme.font.textbase};
  color: ${(props) => props.theme.color.neutral.gray};
  font-weight: 400;
`

export const TableCell = styled.td`
  padding: 0.5rem;
  font-size: ${(props) => props.theme.font.textsm};
  background-color: #f5f5f5;
  color: #000;
`
export const Search = styled.form`
  display: flex;
  padding: 1rem;
  gap: 1rem;
  align-self: flex-end;
  align-items: center;
  justify-content: flex-end;

  > span {
    font-size: ${(props) => props.theme.font.textsm};
    color: ${(props) => props.theme.color.neutral.gray};
  }
`

interface StatusBoxProps {
  status: string
}

export const StatusBox = styled.div<StatusBoxProps>`
  color: ${(props) => props.theme.color.neutral.white};
  background-color: ${(props) =>
    props.status === 'Em ocorrência'
      ? props.theme.color.red.red600
      : props.status === 'Enviado'
      ? props.theme.color.green.green
      : props.status === 'Não enviado'
      ? props.theme.color.neutral.black
      : props.status === 'ABERTO'
      ? props.theme.color.purple.purple600
      : props.theme.color.purple.purple600};
  padding: 0.5rem;
  border-radius: ${(props) => props.theme.border.radius};
  text-align: center;
  font-size: ${(props) => props.theme.font.textcaption};
  white-space: nowrap;
  cursor: default;
`

export const Footer = styled.footer`
  display: flex;
  position: sticky;
  bottom: 0;
  background-color: #fff;
  padding: 0.5rem;
  align-self: flex-start;
  > span {
    color: ${(props) => props.theme.color.neutral.gray};
    font-size: ${(props) => props.theme.font.textsm};
  }
`
